export const GARENA_SHELLS_MAPPING_KEYS = [
  '25',
  '100',
  '310',
  '520',
  '1060',
  '2180',
  '5600',
  '11500',
  'weekly',
  'monthly',
  'lite',
  '3d',
  '7d',
  '30d',
  'lvl_6',
  'lvl_10',
  'lvl_15',
  'lvl_20',
  'lvl_25',
  'lvl_30',
];

export const KIOSGAMER_MAPPING_KEYS = [
  '5',
  '50',
  '70',
  '140',
  '355',
  '720',
  '7290',
  'id_weekly',
  'id_monthly',
  'id_bp_card',
  'id_lvl_6',
  'id_lvl_10',
  'id_lvl_15',
  'id_lvl_20',
  'id_lvl_25',
  'id_lvl_30',
];

export const ITEM_MAPPING: Record<
  string,
  { label: string; image: string; type: string }
> = {
  // Memberships
  lite: {
    label: 'Weekly Lite',
    type: 'membership',
    image:
      'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="%2300bfff"><path d="M12 2L2 12l10 10 10-10L12 2z"/></svg>',
  },
  weekly: {
    label: 'Weekly',
    type: 'membership',
    image:
      'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="%2300bfff"><path d="M12 2L2 12l10 10 10-10L12 2z"/></svg>',
  },
  monthly: {
    label: 'Monthly',
    type: 'membership',
    image:
      'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="%2300bfff"><path d="M12 2L2 12l10 10 10-10L12 2z"/></svg>',
  },
  // BUNDLES / VIP PACKS
  vip1: {
    label: 'VIP PACK 1',
    type: 'bundle',
    image: 'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="%23888888"><path d="M21 6H3c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-10 7H8v3H6v-3H3v-2h3V8h2v3h3v2zm4.5 2c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm4-3c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"/></svg>',
  },
  member_lite: {
    label: 'MEMBER COMBO',
    type: 'bundle',
    image: 'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="%23888888"><path d="M21 6H3c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-10 7H8v3H6v-3H3v-2h3V8h2v3h3v2zm4.5 2c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm4-3c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"/></svg>',
  },
  // Diamond Packs
  '25': {
    label: '25 💎',
    type: 'diamond',
    image:
      'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="%2300bfff"><path d="M12 2L2 12l10 10 10-10L12 2z"/></svg>',
  },
  '100': {
    label: '100 💎',
    type: 'diamond',
    image:
      'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="%2300bfff"><path d="M12 2L2 12l10 10 10-10L12 2z"/></svg>',
  },
  '310': {
    label: '310 💎',
    type: 'diamond',
    image:
      'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="%2300bfff"><path d="M12 2L2 12l10 10 10-10L12 2z"/></svg>',
  },
  '520': {
    label: '520 💎',
    type: 'diamond',
    image:
      'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="%2300bfff"><path d="M12 2L2 12l10 10 10-10L12 2z"/></svg>',
  },
  '1060': {
    label: '1060 💎',
    type: 'diamond',
    image:
      'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="%2300bfff"><path d="M12 2L2 12l10 10 10-10L12 2z"/></svg>',
  },
  '2180': {
    label: '2180 💎',
    type: 'diamond',
    image:
      'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="%2300bfff"><path d="M12 2L2 12l10 10 10-10L12 2z"/></svg>',
  },
  '5600': {
    label: '5600 💎',
    type: 'diamond',
    image:
      'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="%2300bfff"><path d="M12 2L2 12l10 10 10-10L12 2z"/></svg>',
  },
  '11500': {
    label: '11500 💎',
    type: 'diamond',
    image:
      'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="%2300bfff"><path d="M12 2L2 12l10 10 10-10L12 2z"/></svg>',
  },

  // Evo Access
  '3d': {
    label: 'Evo 3D',
    type: 'evo',
    image:
      'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="%2300bfff"><path d="M12 2L2 12l10 10 10-10L12 2z"/></svg>',
  },
  '7d': {
    label: 'Evo 7D',
    type: 'evo',
    image:
      'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="%2300bfff"><path d="M12 2L2 12l10 10 10-10L12 2z"/></svg>',
  },
  '30d': {
    label: 'Evo 30D',
    type: 'evo',
    image:
      'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="%2300bfff"><path d="M12 2L2 12l10 10 10-10L12 2z"/></svg>',
  },

  // Indonesia-specific products (kiosgamer)
  '5': {
    label: '5 💎',
    type: 'diamond',
    image:
      'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="%2300bfff"><path d="M12 2L2 12l10 10 10-10L12 2z"/></svg>',
  },
  '50': {
    label: '50 💎',
    type: 'diamond',
    image:
      'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="%2300bfff"><path d="M12 2L2 12l10 10 10-10L12 2z"/></svg>',
  },
  '70': {
    label: '70 💎',
    type: 'diamond',
    image:
      'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="%2300bfff"><path d="M12 2L2 12l10 10 10-10L12 2z"/></svg>',
  },
  '140': {
    label: '140 💎',
    type: 'diamond',
    image:
      'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="%2300bfff"><path d="M12 2L2 12l10 10 10-10L12 2z"/></svg>',
  },
  '355': {
    label: '355 💎',
    type: 'diamond',
    image:
      'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="%2300bfff"><path d="M12 2L2 12l10 10 10-10L12 2z"/></svg>',
  },
  '720': {
    label: '720 💎',
    type: 'diamond',
    image:
      'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="%2300bfff"><path d="M12 2L2 12l10 10 10-10L12 2z"/></svg>',
  },
  '7290': {
    label: '7290 💎',
    type: 'diamond',
    image:
      'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="%2300bfff"><path d="M12 2L2 12l10 10 10-10L12 2z"/></svg>',
  },
  id_weekly: {
    label: 'Weekly (ID)',
    type: 'membership',
    image:
      'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="%2300bfff"><path d="M12 2L2 12l10 10 10-10L12 2z"/></svg>',
  },
  id_monthly: {
    label: 'Monthly (ID)',
    type: 'membership',
    image:
      'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="%2300bfff"><path d="M12 2L2 12l10 10 10-10L12 2z"/></svg>',
  },
  id_bp_card: {
    label: 'BP Card (ID)',
    type: 'membership',
    image:
      'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="%2300bfff"><path d="M12 2L2 12l10 10 10-10L12 2z"/></svg>',
  },

  // Level Up Pass
  lvl_6: {
    label: 'Level 6 Pass',
    type: '120 💎',
    image:
      'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="%2300bfff"><path d="M12 2L2 12l10 10 10-10L12 2z"/></svg>',
  },
  lvl_10: {
    label: 'Level 10 Pass',
    type: '215 💎',
    image:
      'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="%2300bfff"><path d="M12 2L2 12l10 10 10-10L12 2z"/></svg>',
  },
  lvl_15: {
    label: 'Level 15 Pass',
    type: '215 💎',
    image:
      'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="%2300bfff"><path d="M12 2L2 12l10 10 10-10L12 2z"/></svg>',
  },
  lvl_20: {
    label: 'Level 20 Pass',
    type: '215 💎',
    image:
      'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="%2300bfff"><path d="M12 2L2 12l10 10 10-10L12 2z"/></svg>',
  },
  lvl_25: {
    label: 'Level 25 Pass',
    type: '215 💎',
    image:
      'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="%2300bfff"><path d="M12 2L2 12l10 10 10-10L12 2z"/></svg>',
  },
  lvl_30: {
    label: 'Level 30 Pass',
    type: '375 💎',
    image:
      'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="%2300bfff"><path d="M12 2L2 12l10 10 10-10L12 2z"/></svg>',
  },
  id_lvl_6: {
    label: 'Level 6 Pass (ID)',
    type: '120 💎',
    image:
      'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="%2300bfff"><path d="M12 2L2 12l10 10 10-10L12 2z"/></svg>',
  },
  id_lvl_10: {
    label: 'Level 10 Pass (ID)',
    type: '215 💎',
    image:
      'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="%2300bfff"><path d="M12 2L2 12l10 10 10-10L12 2z"/></svg>',
  },
  id_lvl_15: {
    label: 'Level 15 Pass (ID)',
    type: '215 💎',
    image:
      'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="%2300bfff"><path d="M12 2L2 12l10 10 10-10L12 2z"/></svg>',
  },
  id_lvl_20: {
    label: 'Level 20 Pass (ID)',
    type: '215 💎',
    image:
      'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="%2300bfff"><path d="M12 2L2 12l10 10 10-10L12 2z"/></svg>',
  },
  id_lvl_25: {
    label: 'Level 25 Pass (ID)',
    type: '215 💎',
    image:
      'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="%2300bfff"><path d="M12 2L2 12l10 10 10-10L12 2z"/></svg>',
  },
  id_lvl_30: {
    label: 'Level 30 Pass (ID)',
    type: '375 💎',
    image:
      'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="%2300bfff"><path d="M12 2L2 12l10 10 10-10L12 2z"/></svg>',
  },
};
